import { useNewRoleContext } from 'lib/context/Role/NewRoleContext/NewRoleContext';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import WizardModal from 'components/shared/Modal/WizardModal/WizardModal';

import FooterButtons from '../components/FooterButtons';
import AssignRole from '../components/NewRole/AssignRole/AssignRole';
import RoleDetails from '../components/NewRole/RoleDetails/RoleDetails';
import ManagePermissions from '../components/NewRole/ManagePermissions/ManagePermissions';

const NewRoleModal = ({ forAdmin }) => {
  const { showNewRoleModal, breadCrumbs, setBreadCrumbs, handleClose } = useNewRoleContext();

  const actionViews = {
    role_details: {
      component: <RoleDetails forAdmin={forAdmin} />,
      footer: (
        <FooterButtons
          buttonText="Set Permissions"
          nextTo="manage_permissions"
          showNavigationButtons
          firstStep={true}
          setBreadCrumbs={setBreadCrumbs}
        />
      )
    },
    manage_permissions: {
      component: <ManagePermissions forAdmin={forAdmin} />,
      footer: (
        <FooterButtons
          buttonText="Assign Role"
          backTo="role_details"
          nextTo="assign_role"
          showNavigationButtons
          setBreadCrumbs={setBreadCrumbs}
          ableToSave
        />
      )
    },
    assign_role: {
      component: <AssignRole forAdmin={forAdmin} />,
      footer: (
        <FooterButtons
          buttonText="Save Role"
          backTo="manage_permissions"
          isLastStep
          setBreadCrumbs={setBreadCrumbs}
        />
      )
    }
  };

  const getCurrentView = () => {
    const currentView = breadCrumbs?.find((row) => row.active)?.view;
    return actionViews[currentView]?.component ?? null;
  };

  const getCurrentFooter = () => {
    const currentView = breadCrumbs?.find((row) => row.active)?.view;
    return actionViews[currentView]?.footer ?? null;
  };

  return (
    <WizardModal
      isOpen={showNewRoleModal}
      handleClose={handleClose}
      title="Create new role"
      breadcrumbs={breadCrumbs}
      setBreadCrumbs={setBreadCrumbs}
      footerButtons={getCurrentFooter()}
      modalWidth="medium">
      {getCurrentView()}
    </WizardModal>
  );
};

export default withErrorBoundary(NewRoleModal);
